module.exports = __webpack_public_path__ + "static/media/poster.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IntroSection/poster.png
// module id = 67
// module chunks = 0